export { PaymentMethodsStacked } from './PaymentMethodsStacked';
